import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const AcceptanceOfTerms = () => {
  return (
    <PrivacyPolicyContainer>
      <h4>Acceptance of Terms</h4>
      <p>
        By accessing or using the Yoda Safety Services platform, including but
        not limited to the training portal, courses, quizzes, newsletters, and
        payment services, users agree to be bound by the Terms & Conditions
        outlined in this Privacy Policy and our Terms of Service.
      </p>
      <p>Users acknowledge and agree to the following:</p>
      <ul>
        <li>
          Access to the training portal, courses, and quizzes is subject to
          compliance with these terms.
        </li>
        <li>
          Payments made through PayPal or other payment processors are governed
          by their respective terms and conditions.
        </li>
        <li>
          Users are responsible for maintaining the confidentiality of their
          account credentials and for all activities conducted under their
          accounts.
        </li>
        <li>
          Company accounts may be subject to additional terms and conditions as
          agreed upon during registration.
        </li>
        <li>
          By subscribing to our newsletters, users consent to receive periodic
          updates and promotional communications. Users may opt out at any time.
        </li>
      </ul>
      <p>
        If you do not agree to these terms, you must refrain from using the
        platform.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default AcceptanceOfTerms;
